import { CustomerType } from "@origin-digital/platform-enums";
import { IMcAppType, NavFlow, Tab } from "../mcApp.types";

export const homeEnergyOverview: IMcAppType = {
  name: "homeEnergyMonitor_SAP",
  path: "/my-account/home-energy-overview",
  description: "Origin home energy overview",
  navFlow: NavFlow.STANDARD,
  title: "Home energy overview",
  parent: Tab.MORE,
  conditions: {
    intent: "homeEnergyOverview",
    customerType: CustomerType.sap,
  },
};
